export default __webpack_public_path__ + "static/media/flashingarc4.83838736.png";